import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentWallet } from 'ospg-payment-wallet';
import * as ReactDom from "react-dom";
import * as React from "react";
import { SubscriptionService } from "../../../shared/services/subscription.service";
import { ModalService } from "../../../shared/services/modal.service";
import { AuthService } from "../../../shared/services/auth.service";
import { TermsContentComponent } from "../../../shared/components/terms-content/terms-content.component";
import { _windowUtil } from '../../../shared/utils/ui-utils';
import { properties } from 'src/environments/properties';

declare const $: any;

@Component({
  selector: 'app-update-plan',
  templateUrl: './update-plan.component.html',
  styleUrls: ['./update-plan.component.scss']
})
export class UpdatePlanComponent implements OnInit {
  @Input() paymentType = '';
  @Input() userSubscriptionDetails: any;
  @Input() userInfo: any;
  @Input() tenderInfo: any = {};
  @Input() userEnrollmentDetails: any;
  @Input() changeCode: any;
  @Input() termsID: any;
  @Input() currentEnvironment;
  @Input() retentionPlanDiscount;
  properties = properties;
  imgUrl: string;
  showLoader = false;
  tenderErrorMessage = '';
  isTokenChanged = false;
  isUpdating = false;
  termsId;
  public tc = false;
  public cvvErrorMessage = '';
  public displayErrorMessage = '';
  public API_FAIL_ERROR_MESSAGE = properties.paymentModel.API_FAIL_ERROR_MESSAGE;
  public UNKNOWN_ERROR_MESSAGE = properties.paymentModel.UNKNOWN_ERROR_MESSAGE;
  public scene7PresetDefaulImage = '&defaultImage=Not_Available';
  public scene7PresetCCIcon = '?$ccicon$';
  public enableCheckbox: boolean = false;
  public displayCheckbox: boolean = false;
  isB2B;

  public checkBoxEnable;
  public isCheckBoxVisible;
  public openPopup;

  public windowUtil = _windowUtil(window);

  constructor(
    public subscriptionService: SubscriptionService,
    private modalService: ModalService,
    public authService: AuthService,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    if (this.tenderInfo) {
      this.isB2B = this.authService.checkB2B();
      this.loadIcons();
      this.showComponent();
    }
  }

  public tcCheck() {
    this.tc = !this.tc;
  }

  public setErrorMessage(errorCode?: string): void {
    this.showLoader = false;
    this.displayErrorMessage = errorCode === 'OSMS-SUBSCRIPTION-0000' ? this.UNKNOWN_ERROR_MESSAGE : this.API_FAIL_ERROR_MESSAGE;
  }

  public setTenderErrorMessage(errorCode?: string): void {
    this.showLoader = false;
    this.tenderErrorMessage = this.API_FAIL_ERROR_MESSAGE;
  }

  public resetValues() {
    this.displayErrorMessage = '';
    this.cvvErrorMessage = '';
  }

  showComponent() {
    let checkboxEnable = (bool: boolean) => {
      // Based on the bool value (i.e either true/false) this method can be used to enable or disable checkbox
      this.enableCheckbox = bool
    }
    let isCheckboxVisible = (bool: boolean) => {
      // Based on the bool value (i.e either true/false) this method can be used to make the checkbox hidden/visible
      if (bool) {
        $('.terms-condition-submit-section').removeClass('mask');
      } else {
        $('.terms-condition-submit-section').addClass('mask');
      }
    }
 
    let openPopUp = (event) => {
      this.currentEnvironment = this.subscriptionService.getEnvironment();
      this.subscriptionService.getTerms(this.userInfo, this.currentEnvironment).subscribe((data) => {
        if (data && data.content) {
          this.modalService.openModalWithComponent(TermsContentComponent, {
            initialState: {
              userInfo: this.userInfo,
              content: data.content
            },
            class: 'slot-picker-modal',
            backdrop: 'static',
            ariaDescribedby: 'slot-msg',
            ariaLabelledBy: "dialoghead-slot-details",
          });
        }
      });
    }

    this.checkBoxEnable = checkboxEnable;
    this.isCheckBoxVisible = isCheckboxVisible;
    this.openPopup = openPopUp;

    let paymentMethods = [];
    if (this.tenderInfo && this.tenderInfo.defaultAccount) {
      paymentMethods.push(this.tenderInfo);
    }
    ReactDom.render(React.createElement(
      PaymentWallet,
      {
        client: "FreshPass",
        paymentMethodContext: "FRESH_PASS",
        freshPassFlow: "subscription",
        paymentMethods: paymentMethods,
        shopToken: this.userInfo?.SWY_SHOP_TOKEN,
        checkboxEnable: checkboxEnable,
        isCheckboxVisible: isCheckboxVisible,
        openPopUp: openPopUp,
        ...(this.isB2B && { "customerType": "B" })
      }
    ), document.getElementById("paymentFrame"))
  }

  setCVVForSubscription(): void {
    this.isUpdating = true;
    let parameters = {
      "gid": this.userEnrollmentDetails.gid,
      "promotionFee": 25,
      "subscriptionCode": this.changeCode,
      "termsVersionId": this.termsID,
      ...(this.retentionPlanDiscount?.discountType && { "discountType": this.retentionPlanDiscount.discountType }),
      ...(this.retentionPlanDiscount?.campaignType && { "campaignType": this.retentionPlanDiscount.campaignType }),
    };
    let paramString = JSON.stringify(parameters);

    this.subscriptionService.changePlan(this.userInfo, paramString, this.userEnrollmentDetails.gid, this.currentEnvironment).subscribe((data: any) => {
      let response = data.Data
      let newSubscriber;
      let subscriptionStatus;
      if (response) {
        this.analyticsUpdateCTATracking()
        newSubscriber = response.newSubscriber;
        subscriptionStatus = response.subscriptionStatus;
        if (subscriptionStatus === 'Cancelled') {
            newSubscriber = true;
        }
        if (newSubscriber === false) {
          let temp = 'You have successfully updated your plan.'
          let tempMessage = { message: temp, isDisplayed: false };
          let message = JSON.stringify(tempMessage);
          localStorage.setItem('notifyMessage', message);
        }
        this.redirectToManagePlan()
      } else {
        this.setErrorMessage();
      }
      this.isUpdating = false;
    },
      error => {
        this.setErrorMessage();
        $('.update-button').removeClass('mask');
        $('.ds-banner-submit-busy-loading').addClass('mask');
        this.isUpdating = false;
      },
      () => {
        this.isUpdating = false;
      }
    );
  }

  loadIcons() {
    if (this.tenderInfo.cardType) {
      this.tenderInfo.ccIcon = 'https://images.albertsons-media.com/is/image/ABS/' + 'sub_' + this.tenderInfo.cardType.toLowerCase() + '_icon' + this.scene7PresetCCIcon + this.scene7PresetDefaulImage;
    }
  }

  openTerms(userSubscriptionDetails, userInfo, freshPassTermsButton?: HTMLButtonElement | undefined) {
    this.activeRoute.data.subscribe(data => {
      let isSessionValid = this.authService.isTokenValidForSession(data.tokenObject)
      if (isSessionValid) {
        const sessionData = { ...(data.tokenObject), authToken: data.tokenObject['SWY_SHOP_TOKEN'] };
        if (sessionData) {
          this.userInfo = sessionData;
          this.subscriptionService.getTerms(this.userInfo, this.currentEnvironment).subscribe((data) => {
            if (data && data.content) {
              this.modalService.openModalWithComponent(TermsContentComponent, {
                initialState: {
                  userInfo: userInfo,
                  content: data.content,
                  lastActiveEle: freshPassTermsButton,
                },
                class: 'slot-picker-modal',
                backdrop: 'static',
                ariaDescribedby: 'slot-msg',
                ariaLabelledBy: 'dialoghead-slot-details',
              });
            }
          });
        }
      } else {
        this.authService.redirectToSSO(data.tokenObject)
      }
    },
      (err => {
        this.authService.redirectToSSO({});
      }));
  }

  analyticsUpdateCTATracking() {
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].analyticsCTATracking(`cta:${window['AB']['DATALAYER'].initPathSections(true).join(':')}|button|plan-update`);
    }
  }

  redirectToManagePlan() {
    this.router.navigate(['freshpass/manage']);
  }
}
